/* عالم سمسم – صفحة المنتج:
   - «التفاصيل» مفتوحة على طول تحت صورة المنتج (من غير +)
   - «سياسة الشحن» اتشالت
   - «تسوق بثقة مع عالم سمسم» بقت كروت واضحة من غير + */
(function () {
  if (window.SMSMPDP) return; window.SMSMPDP = 1;
  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var ICONS = ['✅', '🔄', '💜', '🛡️', '💸', '🚚', '⭐'];

  function css() {
    if (document.getElementById('smsm-pdp-css')) return;
    var s = document.createElement('style'); s.id = 'smsm-pdp-css';
    s.textContent = '' +
      '.smsm-pd{margin:24px 0 8px;padding:20px 22px;border-radius:18px;background:#fff;border:1px solid #EFE8F7;box-shadow:0 14px 30px -26px rgba(43,23,72,.5)}' +
      '.smsm-pd__h{display:flex;align-items:center;gap:10px;margin:0 0 12px;font-size:18px;font-weight:900;color:#2B1748}' +
      '.smsm-pd__h::before{content:"";width:6px;height:22px;border-radius:6px;background:linear-gradient(180deg,#E2C35A,#BF9A26)}' +
      '.smsm-pd .collapsible-content_inner{margin:0!important}' +
      '.smsm-pd p,.smsm-pd li{line-height:1.9}' +
      '.smsm-tc{margin:20px 0 10px;padding:14px 16px 12px;border-radius:16px;background:linear-gradient(135deg,#E6C866 0%,#D4AF37 55%,#C49B22 100%);border:1px solid #C49B22;box-shadow:0 14px 28px -22px rgba(150,115,20,.8)}' +
      '.smsm-tc__h{margin:0 0 6px;font-size:15px;font-weight:900;color:#512E83;line-height:1.4}' +
      '.smsm-tc__grid{list-style:none;margin:0;padding:0;display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:8px}' +
      '.smsm-tc__it{display:flex;gap:8px;align-items:center;margin:0;padding:8px 10px;background:#fff;border:1px solid rgba(255,255,255,.7);border-radius:12px}' +
      '.smsm-tc__ic{flex:0 0 auto;font-size:16px;line-height:1}' +
      '.smsm-tc__t{font-size:12.5px;font-weight:800;color:#512E83;line-height:1.35}' +
      '.smsm-tc__more{display:inline-block;margin-top:0;font-size:12px;font-weight:800;color:#512E83;text-decoration:underline;text-underline-offset:3px}' +
      '.product-detail__media:has(>.smsm-pd)>.sticky{position:static!important;top:auto!important}' +
      '.product-detail__media>.smsm-pd{position:relative;z-index:1}';
    document.head.appendChild(s);
  }
  /* عنوان التفاصيل حسب نوع المنتج */
  var TT = [
    [/perfume|eau de|extract|oil/i, 'تفاصيل العطر', 'About the fragrance'],
    [/mist|all over spray/i, 'تفاصيل المِست', 'About the mist'],
    [/hair colou?r/i, 'تفاصيل الصبغة', 'About the hair color'],
    [/hair car/i, 'تفاصيل العناية بالشعر', 'Hair care details'],
    [/lotion|moisturi|body wash|body powder|bath/i, 'تفاصيل العناية', 'Care details'],
    [/make-?up/i, 'تفاصيل المكياج', 'Makeup details'],
    [/musk/i, 'تفاصيل المسك', 'About the musk'],
    [/incense/i, 'تفاصيل البخور', 'About the incense'],
    [/candle/i, 'تفاصيل الشمعة', 'About the candle'],
    [/air freshener|diffuser/i, 'تفاصيل معطّر الجو', 'Home scent details'],
    [/watch/i, 'تفاصيل الساعة', 'Watch details'],
    [/jewel/i, 'تفاصيل الطقم', 'Jewelry details'],
    [/bag/i, 'تفاصيل الشنطة', 'Bag details'],
    [/prayer/i, 'تفاصيل السبحة', 'Prayer beads details'],
    [/gift card/i, 'تفاصيل كارت الهدية', 'Gift card details']
  ];
  function ptitle() {
    var t = '';
    try { t = (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product && ShopifyAnalytics.meta.product.type) || ''; } catch (e) {}
    var h1 = document.querySelector('h1'); h1 = h1 ? h1.textContent : '';
    h1 = h1.replace(/\s+/g, ' ').trim();
    if (/مبخرة|burner/i.test(h1)) return EN ? 'About the burner' : 'تفاصيل المبخرة';
    if (/صبغ|hair colou?r|hair dye/i.test(h1)) return EN ? 'About the hair color' : 'تفاصيل الصبغة';
    if (/^(مسك|musk)/i.test(h1) || /^musk$/i.test(t)) return EN ? 'About the musk' : 'تفاصيل المسك';
    if (/^(بخور|معمول|مبثوث|incense|bakhoor|bukhoor|maamoul)/i.test(h1)) return EN ? 'About the incense' : 'تفاصيل البخور';
    for (var i = 0; i < TT.length; i++) if (t && TT[i][0].test(t)) return EN ? TT[i][2] : TT[i][1];
    return EN ? 'Product details' : 'تفاصيل المنتج';
  }
  function head(b) { var h = b.querySelector('.collapsible-heading'); return h ? h.textContent.replace(/\s+/g, ' ').trim() : ''; }

  function run() {
    var blocks = [].slice.call(document.querySelectorAll('collapsible-block'));
    if (!blocks.length) return;
    var media = document.querySelector('.product-detail__media');
    blocks.forEach(function (b) {
      if (b.dataset.smsmP) return;
      var t = head(b), inner = b.querySelector('.collapsible-content_inner') || b.querySelector('.collapsible-content');
      if (/^(التفاصيل|Details|Description|الوصف)/i.test(t)) {
        b.dataset.smsmP = 1; css();
        var box = document.createElement('section'); box.className = 'smsm-pd'; box.dir = EN ? 'ltr' : 'rtl';
        box.innerHTML = '<h2 class="smsm-pd__h">' + ptitle() + '</h2>';
        if (inner) box.appendChild(inner);
        place(box, b, media);
        b.style.display = 'none';
      } else if (/سياسة الشحن|Shipping/i.test(t)) {
        b.dataset.smsmP = 1; b.style.display = 'none';
      } else if (/تسوق بثقة|Shop with confidence|Shop confidently/i.test(t)) {
        b.dataset.smsmP = 1; css();
        var items = [], hs = inner ? inner.querySelectorAll('h6, h5, h4') : [];
        [].forEach.call(hs, function (h) {
          var d = h.nextElementSibling && /^P$/i.test(h.nextElementSibling.tagName) ? h.nextElementSibling.innerHTML : '';
          var tt = h.textContent.trim();
          if (/حفاظ|استرداد|quality|refund/i.test(tt)) { items.push(null); return; }
          items.push({ t: tt, d: d });
        });
        if (!items.length) { b.querySelector('.collapsible-heading') && (b.querySelector('.collapsible-heading').style.display = 'none'); return; }
        var card = document.createElement('section'); card.className = 'smsm-tc'; card.dir = EN ? 'ltr' : 'rtl';
        card.innerHTML = '<h3 class="smsm-tc__h">' + (EN ? '✦ The Golden Guarantee with SMSM World' : '✦ الضمان الذهبي مع سمسم ورلد') + '</h3>' +
          '<a class="smsm-tc__more" href="' + (EN ? '/en' : '') + '/policies/refund-policy">' + (EN ? 'Exchange & return terms →' : 'شروط الاستبدال والإرجاع ←') + '</a>';
        b.parentNode.insertBefore(card, b);
        b.style.display = 'none';
      }
    });
  }
  /* التفاصيل: تحت الصورة على الكمبيوتر — وعلى الموبايل تحت زرار الشراء عشان الزرار يفضل قريب */
  var pdBox, pdHome;
  function place(box, b, media) {
    pdBox = box; pdHome = b;
    position(media);
    window.addEventListener('resize', function () { position(document.querySelector('.product-detail__media')); });
  }
  function position(media) {
    if (!pdBox) return;
    var desk = window.matchMedia('(min-width: 768px)').matches;
    if (desk && media) { if (pdBox.parentNode !== media) media.appendChild(pdBox); }
    else if (pdHome && pdHome.parentNode && pdBox.previousElementSibling !== pdHome) pdHome.parentNode.insertBefore(pdBox, pdHome.nextSibling);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
